import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Spinner, Alert, Card, ListGroup, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { announcementService } from '../services/api';
import './AnnouncementsList.css';

const AnnouncementsList = () => {
  const navigate = useNavigate();
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchAllAnnouncements();
  }, []);

  const fetchAllAnnouncements = async () => {
    try {
      setLoading(true);
      const response = await announcementService.getAnnouncements();
      setAnnouncements(response.data.announcements);
    } catch (err) {
      setError('Failed to load announcements');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleAnnouncementClick = (announcement) => {
    navigate(`/announcement/${announcement.id}`);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  if (loading) {
    return (
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col md={8} className="text-center">
            <Spinner animation="border" />
            <p className="mt-3">Loading announcements...</p>
          </Col>
        </Row>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col md={8}>
            <Alert variant="danger">{error}</Alert>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={10}>
          <Card className="announcements-list-card">
            <Card.Header className="bg-primary text-white">
              <h3 className="mb-0">All Announcements</h3>
              <p className="mb-0 mt-1">Controller of Examinations - Andhra Loyola College</p>
            </Card.Header>
            <Card.Body className="p-0">
              {announcements.length === 0 ? (
                <div className="text-center p-5 text-muted">
                  <i className="fas fa-info-circle fa-3x mb-3"></i>
                  <h5>No announcements available</h5>
                  <p>Please check back later for updates.</p>
                </div>
              ) : (
                <ListGroup variant="flush">
                  {announcements.map((announcement) => (
                    <ListGroup.Item
                      key={announcement.id}
                      className="announcement-list-item"
                      onClick={() => handleAnnouncementClick(announcement)}
                      style={{ cursor: 'pointer' }}
                    >
                      <Row className="align-items-center">
                        <Col md={8}>
                          <div className="announcement-content">
                            <h5 className="announcement-title mb-1">{announcement.title}</h5>
                            <small className="text-muted">
                              <i className="fas fa-calendar-alt me-1"></i>
                              Posted on: {formatDate(announcement.announcement_date)}
                            </small>
                          </div>
                        </Col>
                        <Col md={4} className="text-end">
                          <div className="announcement-actions">
                            <Button variant="outline-primary" size="sm">
                              <i className="fas fa-eye me-1"></i>
                              View Details
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AnnouncementsList;